__turbopack_context__.v({
  "diagonal": "SelectablePrint-module__stOHia__diagonal",
  "matrix": "SelectablePrint-module__stOHia__matrix",
  "section": "SelectablePrint-module__stOHia__section",
  "sheet": "SelectablePrint-module__stOHia__sheet",
  "standings": "SelectablePrint-module__stOHia__standings",
});
